// ════════════════════════════════════════════════════════════════════
// TERROR — V'AEL'S TOOLS
// The things she lends you. Row one is THE VEIL, and it is FREE.
// ────────────────────────────────────────────────────────────────────
// caP'n, 2026-09-07, handing the beat over:
//
//   *"SHV sends his Lyt avatar to find the intruders — after defeating
//    it they are cloaked by V'ael's Veil as long as they move at a
//    snails pace they will remain undetected... the price for such a
//    powerful tool..s! plural!... You know what D'Aeternuz's feed
//    upon, I need not explain"*
//
// ⚠ HE LATER RULED THAT PRICE AT ZERO — 2026-09-15, *"completely free
// :3 purely narrative"*. The quote above stays verbatim because it is
// what he said on the 7th; it is NOT a live cost. See THE PRICE below.
//
// ── WHY THIS IS A TABLE AND NOT A BOOLEAN CALLED `hasVeil` ──────────
// He said "tool..s! plural!" and then stopped. Whatever the second one
// turns out to be, it is a ROW here and no code — THE EXCEPTION LAW,
// the same reason WORLD_GATES is a list with one doorman in it.
//
// So: the Veil is not special-cased anywhere. Everything that reads it
// reads `TOOLS`, and a second tool with a different `wonFrom`, a
// different pace and a different price is authoring, not engineering.
//
// ── THE THREE FACTS THE VEIL IS BUILT OUT OF ────────────────────────
//   1. YOU WIN IT BY BEATING THE LYT AVATAR. That fight already
//      exists — it is `WORLD_GATES.hosh_door`, the doorman you must
//      put down before the map opens. The Veil is what walking away
//      from it is worth.
//   2. IT HOLDS WHILE YOU CREEP. Veiled, the map walks at `stepSpeed`
//      instead of WorldMap's ordinary STEP_SPEED. Slow IS the cloak.
//   3. IT DOES NOT COVER A CUT. A warp and a sky door are not slow
//      travel, they are a body that was never in between — so they
//      break it. See `breaksOn`, and THE TWO-COLOUR LAW: red is a road
//      you WALK (covered), yellow is a link you TAKE (not).
//
// ── THE PRICE: THERE ISN'T ONE. SETTLED. ────────────────────────────
// ⭐ caP'n, 2026-09-15, asked outright what the Veil costs:
//
//   *"completely free :3 purely narrative"*
//
// That is the ruling and it is final. The Veil charges NOTHING: no
// Aenergy, no Anima, no per-step debt, no ledger, no bill in the
// chrome. Everything in this file that still SPEAKS of a price is
// flavour text, kept because it is good writing, and it lives on the
// tool row under the field name `flavour` so it cannot be mistaken
// for a number. There is no amount to tune and nothing to wire.
//
// ⛔ DO NOT RE-DERIVE THIS QUESTION. The banner that used to sit here
// said the price "does not bite the duel yet, on purpose" and that
// making it cost real Anima was "caP'n's to say when". HE HAS SAID.
// The answer was FREE, so the debt that was being counted was never
// collected and now never will be: `stepCost` returns nothing,
// `addSteps` keeps only a step count, `ledgerLine` names no bill, and
// `worldMap/veil` no longer persists an `owed` map. If you are here
// because you want the Veil to cost something, that is a NEW ruling
// you need from caP'n — it is not a TODO somebody left for you.
//
// ⚠ AND IT WAS NEVER ACTUALLY WIRED, whatever the old banner claimed.
// It said the debt was "counted, shown in the chrome, and persisted".
// It was none of the three: nothing ever called `addSteps`, no chrome
// ever rendered `ledgerLine`, and `saveVeilLedger` in worldData.js had
// no callers. The ruling did not switch a live price off; it closed a
// question before anything depended on the answer.
//
// ── WHY THE VEIL EXISTS AT ALL — THE PLOT HOLE IT FILLS ─────────────
// ⭐ caP'n, 2026-09-14, verbatim. This is the whole justification for
// the thing and it is written down nowhere else:
//
//   *"the veil was more Narrative, just filling the plot hole of why
//    the couple aren't just immediately swarmmed after the first
//    battle since their location is revealed. The cloak is the reason
//    they can freely move around the Overworld... they keep using the
//    Veil to move undetected so its just impossible, he's too low
//    level only when they close enough can he send someone that's
//    when the 'battles' start they are forced to fight pivotal
//    location in order to progress in the map and that's the best SHV
//    can do to halt their progress because the player can ultimately
//    just head back to the plaza at any point, swarming one location
//    would prove unwise as it leaves other spots unattended."*
//
// So the Veil is LOAD-BEARING STORY, not an economy. It is the answer
// to "why is the Overworld walkable at all, once SHV knows where they
// are" — and the answer is that he cannot afford to swarm one place
// while the player can simply walk back to the plaza. Its only teeth
// are the two dials in the row below: `stepSpeed`, because slow IS the
// cloak, and `breaksOn`, because a cut is not slow travel. A gate is
// SHV finally getting close enough to send someone; the fight there is
// what progress costs, and it is the ONLY thing that costs anything.
//
// ── THE TWO AENERGIES THE FLAVOUR NAMES ────────────────────────
// Kept for the writing only — nothing computes on either of them.
// *"You know what D'Aeternuz's feed upon, I need not explain"*, and
// the vault does say it, verbatim, in
// `Final Boss/Book_Krush/Lore/The Tribes - A'oeternuz & A'aeternuz.md`:
//
//   *"Beings who deal with their A' allow some of their Aenergy to be
//    forever transferred or kept on standby, takeable at any moment —
//    J'ynxi's whole economy runs on this."*
//
// FOREVER TRANSFERRED and KEPT ON STANDBY are therefore the two SHAPES
// the flavour rows name, and that is the "tool..s! plural!". Which two
// Aenergies is still only a PLACEHOLDER: the same vault file rules that
// *"the D/A shorthand is retired... Old 'D' alone = Ao"*, and the Ao
// (A'oeternuz) *"follow Omnia, after Khao and Lyf."* So "D'Aeternuz"
// reads as **Ao — Khao and Lyf**, which is what the rows below say. If
// caP'n ever means Ae (Anima and Lyt) instead, it is two strings on two
// rows and nothing else moves, because nothing reads them to charge.
// ════════════════════════════════════════════════════════════════════

// ── THE TWO SHAPES, AS STORY VOCABULARY ────────────────────────
// ⛔ THESE ARE WORDS, NOT PRICES. Kept because the flavour rows below
// use them, and because the story names them: `standby` is the one
// that is frightening — she has not taken it, she can, at any moment.
// Nothing reads either value to charge anybody anything; the Veil is
// free (2026-09-15). They are labels for a chrome that wants to say
// which KIND of nothing it is.
export const PRICE_KEEP = "standby";      // hers to take, whenever
export const PRICE_GONE = "transferred";  // already gone

export const TOOLS = [
  {
    id: "vaels_veil",
    name: "V'ael's Veil",
    lender: "V'ael",
    lenderTitle: "The One Who Was Left",
    accent: "#c9a84c",

    // ⬡ WON FROM A GATE, NOT A NODE. The doorman is not on the map —
    // see WORLD_GATES in worldData. A tool won from a NODE instead is
    // `wonFrom: { node: "AAC-01" }` and the reader already handles it.
    wonFrom: { gate: "hosh_door" },

    // What the chrome prints while it is on you.
    line: "Move like something that was never here.",
    // What the chrome prints the moment it drops.
    broke: "You took the fast way. Something looked up.",

    // ⚑ THE SNAIL'S PACE — map pixels per frame while veiled.
    // WorldMap's ordinary walk is STEP_SPEED = 2.4, so this is roughly
    // a third of it: slow enough to read as creeping, short of a wait.
    // A DIAL. Tune it with a controller in hand, not here.
    stepSpeed: 0.8,

    // ⚑ WHAT BREAKS IT. Strings, matched against a path's `via`, so a
    // future kind of travel that should also break it is one word.
    breaksOn: ["warp", "sky"],

    // ⬡ WHAT SHE SAYS WHEN SHE HANDS IT OVER.
    // ⚠ PLACEHOLDER, written against TERROR_STORY_SPINE.md — caP'n:
    // *"I will add dialogue to the game, for now you just show up to
    // nodes, defeat the enemy, and move on."* Format is StoryScript's:
    // a bare line is the speaker, [brackets] are the player, *stars*
    // are stage directions. Overwrite freely; nothing reads the words.
    //
    // 🔴 It does not say X'aol, it does not say that J'ynxi's seal
    // never fit, and it does not explain why the Sol is recoverable.
    // Those are the three things Minerium One must never say — see the
    // banner at the top of minerium1.js.
    grantScene: {
      speaker: "V'ael",
      speakerTitle: "The One Who Was Left",
      accent: "#c9a84c",
      lines: [
        "*The door falls. Not the way a body falls — the way a sentence falls when somebody stops saying it.*",
        "*She is there. Which is not the same as having arrived.*",
        "He sent that to find you. Not to stop you.",
        "[Then he knows where we are.]",
        "He knew before you knocked. That is what a door is for.",
        "*She does something small with two fingers, and the light forgets the shape of you.*",
        "It covers a thing moving through a place. It does not cover a thing that was never in between.",
        "So walk. Slowly. Every road on this map is yours while you are slow on it — and the moment you take the short way, you are a person again.",
        "[And the cost.]",
        "*She looks pleased to have been asked.*",
        "You know what my kind feed on. I am not going to insult you by explaining it.",
        "Some of it is gone. You will not feel it go.",
        "Some of it is only... on standby. Mine, the moment I reach.",
        "[That is two prices.]",
        "It is. It is a very good cloak.",
      ],
    },

    // ⛔ NARRATIVE FLAVOUR. CHARGES NOTHING. NOT A PRICE.
    // caP'n, 2026-09-15: *"completely free :3 purely narrative"*. So
    // this is WRITING, deliberately kept — he likes placeholders he
    // can edit later — and the field is called `flavour` rather than
    // `price` precisely so that no chrome can read it as a live cost
    // and wire it up. THERE IS NO `perStep` HERE ON PURPOSE: an amount
    // is the one field that would let this become a bill again.
    // Rewrite the `line`s freely; nothing computes on any of it. If
    // the Veil is ever meant to cost something, that is a new ruling
    // from caP'n and a new field — see THE PRICE in the banner.
    flavour: [
      { aenergy: "Khao", mode: PRICE_GONE,
        line: "Khao, forever transferred. You will not feel it go." },
      { aenergy: "Lyf",  mode: PRICE_KEEP,
        line: "Lyf, kept on standby. Hers, the moment she reaches." },
    ],
  },
];

export const TOOL_BY_ID = Object.fromEntries(TOOLS.map(t => [t.id, t]));
export const VEIL = TOOL_BY_ID.vaels_veil;

// ── WHAT THE SAVE HOLDS ─────────────────────────────────────────────
// `worldMap/tools/{id}`  — an append-only stamp. You have it, once
//                          ever, same write path as gates and clears.
// `worldMap/veil`        — the STEP COUNT: { steps }. How far they
//                          have crept under the cloak, and nothing
//                          else. Mutable, like `at`, because it is a
//                          running total and not a thing you earned.
//                          ⛔ THERE IS NO `owed` MAP ANY MORE — the
//                          Veil is free (2026-09-15). An old save may
//                          still carry one; it is never read and never
//                          written again. Do not add it back.
// Both are FIELDS under a profile node that already exists, so neither
// needs a rules deploy (IE_FIREBASE_LAW §2).
export const TOOL_KEEP   = "tools";
export const LEDGER_KEEP = "veil";

// Do you hold this tool? Reads the raw progress, so callers that have
// not built a ctx (App's gate branch) can ask too.
export const holdsTool = (progress, toolId) =>
  !!((progress && progress[TOOL_KEEP]) || {})[toolId];

export const holdsVeil = (progress) => holdsTool(progress, VEIL.id);

// Every tool this save has been handed, in table order.
export const toolsHeld = (progress) =>
  TOOLS.filter(t => holdsTool(progress, t.id));

// The tool a gate hands over when it falls, or null. Derived from the
// tool's own `wonFrom` rather than a field on the gate, so a tool is
// authored in exactly one place.
export const toolWonFromGate = (gateId) =>
  TOOLS.find(t => t.wonFrom?.gate === gateId) || null;

export const toolWonFromNode = (nodeId) =>
  TOOLS.find(t => t.wonFrom?.node === nodeId) || null;

// ── THE PACE ────────────────────────────────────────────────────────
// The walking speed this save should use, given the ordinary one.
// Returns the SLOWEST pace any held tool imposes — two cloaks do not
// make you faster.
export function paceFor(progress, ordinary) {
  const held = toolsHeld(progress).filter(t => Number.isFinite(t.stepSpeed));
  if (!held.length) return ordinary;
  return held.reduce((slow, t) => Math.min(slow, t.stepSpeed), ordinary);
}

// ── WHAT BREAKS IT ──────────────────────────────────────────────────
// `via` is the path's own kind — "warp", "sky", or undefined for an
// ordinary road. Returns the tool that just dropped, or null.
export function toolBrokenBy(progress, via) {
  if (!via) return null;
  return toolsHeld(progress).find(t => (t.breaksOn || []).includes(via)) || null;
}

// ── THE STEP COUNT (WAS THE LEDGER) ─────────────────────────
// ⭐ WHAT ONE MORE VEILED STEP COSTS: NOTHING. caP'n, 2026-09-15, asked
// what the Veil costs — *"completely free :3 purely narrative"*.
//
// Kept as a function, and kept deliberately empty, so the one question
// a caller might ask has a truthful answer rather than no answer:
// `Object.keys(stepCost(p)).length === 0` for every save, forever. A
// fresh object each call, so a caller that mutates what it gets back
// cannot poison the next one.
//
// ⛔ IF THIS EVER RETURNS SOMETHING AGAIN it is a rules change wearing
// a story's clothes — Khao and Lyf are the duel's own numbers, and a
// tool that quietly opened every Solrend short is exactly what Terror
// cannot afford this close to release. Overturning 2026-09-15 is
// caP'n's call, not a refactor's.
export function stepCost(progress) {
  return {};
}

// The step count after `n` more veiled steps. Never mutates its input.
//
// ⚠ SIGNATURE CHANGED 2026-09-15. It was `addSteps(ledger, cost, n)`
// and it accumulated an `owed` map alongside the count. The Veil is
// free, so the cost argument and the map are both gone. `n` is coerced,
// so a stale three-argument call lands on one step instead of NaN — but
// there were no call sites anywhere in src/ when this changed, so if
// you are reading this after a crash, fix the caller, not this.
export function addSteps(ledger, n = 1) {
  const cur  = ledger || {};
  const more = Number(n);
  return { steps: (Number(cur.steps) || 0) + (Number.isFinite(more) ? more : 1) };
}

// One line for the chrome: "◇ 41 crept". Null before the first step, so
// chrome with nothing to say stays quiet.
//
// ⛔ IT USED TO NAME A DEBT — "◇ 41 crept — 41 Khao, 41 Lyf". That tail
// was a BILL, and the Veil is free (2026-09-15), so it is gone. The
// step count itself is harmless narrative: how far they have crept
// under the cloak. NEVER RE-ATTACH AN AMOUNT TO THIS LINE.
export function ledgerLine(ledger) {
  const steps = Number(ledger && ledger.steps) || 0;
  if (steps <= 0) return null;
  return `◇ ${steps} crept`;
}

// ── THE FLAVOUR ROWS ─────────────────────────────────────
// Every narrative line any held tool carries about what it feeds on,
// for a chrome that wants to print the story of the cloak.
//
// ⚠ RENAMED FROM `priceRows` 2026-09-15, and the old name is the whole
// reason for the rename: it returns WRITING, not amounts, and a thing
// called priceRows invites a chrome to total it and bill somebody. No
// row carries a `perStep`, so there is nothing here to add up.
export function flavourRows(progress) {
  return toolsHeld(progress).flatMap(t => (t.flavour || []).map(p => ({ ...p, tool: t.id })));
}

const vaelsTools = {
  TOOLS, TOOL_BY_ID, VEIL, TOOL_KEEP, LEDGER_KEEP,
  PRICE_KEEP, PRICE_GONE,
  holdsTool, holdsVeil, toolsHeld, toolWonFromGate, toolWonFromNode,
  paceFor, toolBrokenBy, stepCost, addSteps, ledgerLine, flavourRows,
};
export default vaelsTools;
